module.exports = __webpack_public_path__ + "static/media/силовые - Многофункциональныи силовои тренажер.377e08fd.jpg";